import { number, object, SchemaOf, date, string, ref } from 'yup';

import dayjs from 'dayjs';

import { UpdateContractVariables } from '@/graphql/contracts/_generated_/updateContract.mutation';
import { END_DATE_BEFORE_START_DATE, REQUIRED_FIELD, START_DATE_AFTER_END_DATE } from '@/config/text.const';

type FieldKeys = Exclude<keyof UpdateContractVariables['input'], 'contractId'>;

export type Fields = {
  [key in FieldKeys]?: UpdateContractVariables['input'][key];
};

export const validationSchema: SchemaOf<Fields> = object().shape({

  renewableTerm: number()
    .integer()
    .min(0)
    .required(REQUIRED_FIELD),

  contractStartDate: date()
    .optional()
    .test((value, context) => {
      const contractEndDate = context.options.context?.contractEndDate;

      if (!contractEndDate) {
        return context.createError({
          path: 'contractStartDate',
          message: 'Can\'t get "Contract End Date"'
        });
      }

      if (value && dayjs(value).isAfter(dayjs(contractEndDate), 'date')) {
        return context.createError({
          path: 'contractStartDate',
          message: START_DATE_AFTER_END_DATE
        });
      }

      return true;

    }),
  contractEndDate: date()
    .optional()
    .min(ref('contractStartDate'), END_DATE_BEFORE_START_DATE),
  externalContractID: string()
    .nullable()
    .max(100, 'Must be maximum ${max} characters'),
  initialTerm: number()
    .integer()
    .min(0, 'Initial term must be greater than or equal to 0')
});
